// extracted by mini-css-extract-plugin
export default {"phone":"PhoneInput_phone__E0ssb","PhoneInputInput":"PhoneInput_PhoneInputInput__au0mK"};